<template>
  <BasePageContainer class="pt-10">
    <PageHeader
      has-back
      with-members>
      進路活動記録
    </PageHeader>
    <PathActivityForm
      ref="form"
      :user-id="userId"
      @submit="onSubmit" />
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import PathActivityForm from '@/components/view/profile/path_activities/PathActivityForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    PathActivityForm
  },
  mixins: [confirmIfFormChanged()],
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  methods: {
    onSubmit(formData) {
      this.$store.commit('startLoading')
      return this.postPathActivity(formData).then(() => {
        this.$store.commit('notify/set', {message: '進路活動記録を追加しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    postPathActivity(formData) {
      return this.$axios.post('/profiles/path-activities/', formData)
    }
  },
}
</script>

<style>

</style>